/**
 * Ecobalyse edible mass from manufacturing quantity and Sure non-edible ratio.
 * Neutral / missing ratio → edible equals used quantity.
 */
export function edibleQuantityG(usedQuantity: number, nonEdiblePartRatio: number | null | undefined): number {
    const ratio = nonEdiblePartRatio ?? 0;
    return Math.round(usedQuantity * (1 - ratio) * 100) / 100;
}

export function resolveNonEdiblePartRatio(ingredient: {
    ingredientReference?: { nonEdiblePartRatio?: number | null };
}): number | null {
    return ingredient.ingredientReference?.nonEdiblePartRatio ?? null;
}

/** Prefill finished quantity from usedQuantity unless the user already overrode it. */
export function withUsedQuantityChange<
    T extends {
        usedQuantity: number | null;
        quantity: number | null;
        quantityOverridden?: boolean;
        ingredientReference?: { nonEdiblePartRatio?: number | null };
    },
>(ingredient: T, usedQuantity: number | null): T {
    const next = { ...ingredient, usedQuantity };
    if (!ingredient.quantityOverridden && usedQuantity !== null) {
        next.quantity = edibleQuantityG(usedQuantity, resolveNonEdiblePartRatio(ingredient));
    }
    return next;
}
